/* eslint-disable react/jsx-indent */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import i18n from 'i18next';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

import { Typo } from 'uikit/content';
import { NavToggle } from 'uikit/navigation';

import getNavToggleTabs from '../helpers/getNavToggleTabs';

import { InfiniteScrollList, TabsContainer } from '@/exceed';

import { fetchFavoritedVideos, fetchVideosHistory, fetchLiveAndUpcomingVideos } from '../api';

import VideosInfiniteListItem from './videosInfiniteListItem';

import styles from '../styles/myVideos.module.scss';

const MyVideos = ({
  isLoading,
  screenSize,
  handleBrowse,
}) => {
  const isLarge = screenSize === 'large' || screenSize === 'xlarge';

  return (
    <div className={classnames(styles.container, isLarge && styles.isLarge)}>
      <div className={styles.inner_container}>
        <NavToggle selectedValue="my-videos" tabs={getNavToggleTabs()} />
        <Typo className={styles.title} element="h2" variant={isLarge ? 'd07' : 'd06'}>
          {i18n.t('my-videos')}
        </Typo>
        <TabsContainer
          direction={isLarge ? 'vertical' : 'horizontal'}
          tabs={[{
            id: 'live-and-upcoming',
            title: i18n.t('live-and-upcoming'),
            icon: <KeyboardArrowRight />,
            body:
              <InfiniteScrollList
                emptyStateTitle={i18n.t('upcoming-empty-title')}
                emptyStateBody={i18n.t('upcoming-empty-body')}
                emptyStateButtonText={i18n.t('browse')}
                isLoading={isLoading}
                handleEmptyStateClick={handleBrowse}
                queryKey="myVideosLiveAndUpcoming"
                queryFn={fetchLiveAndUpcomingVideos}
                components={{
                  ListItem: VideosInfiniteListItem,
                }}
              />,
          },
          {
            id: 'favorites',
            title: i18n.t('favorites'),
            icon: <KeyboardArrowRight />,
            body:
              <InfiniteScrollList
                emptyStateTitle={i18n.t('favorites-empty-title')}
                emptyStateBody={i18n.t('favorites-empty-body')}
                emptyStateButtonText={i18n.t('browse')}
                isLoading={isLoading}
                handleEmptyStateClick={handleBrowse}
                queryKey="myVideosFavorites"
                queryFn={fetchFavoritedVideos}
                components={{
                  ListItem: VideosInfiniteListItem,
                }}
              />,
          },
          {
            id: 'history',
            title: i18n.t('history'),
            icon: <KeyboardArrowRight />,
            body:
              <InfiniteScrollList
                emptyStateTitle={i18n.t('history-empty-title')}
                emptyStateBody={i18n.t('history-empty-body')}
                emptyStateButtonText={i18n.t('browse')}
                handleEmptyStateClick={handleBrowse}
                isLoading={isLoading}
                queryKey="myVideosHistory"
                queryFn={fetchVideosHistory}
                components={{
                  ListItem: VideosInfiniteListItem,
                }}
              />,
          }]}
          variant="student"
        />
      </div>
    </div>
  );
};

MyVideos.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  screenSize: PropTypes.string.isRequired,
  handleBrowse: PropTypes.func.isRequired,
};

export default React.memo(MyVideos);
